import React, { useState, useEffect, useRef, useContext, useCallback } from "react";
import { BaseRecord } from "@refinedev/core";
import { Link } from "react-router-dom";

//Material Design UI + dependencies
import { FormGroup, FormControlLabel, Switch } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";

//Local Components
import CustomDataGrid from "components/datagrid";
import { encryptData } from "utils/crypto";
import { LoggedInUserContext } from "contexts/loggedInUserContext";

import { LookupsContext } from "contexts/lookupsContext";
import { ApprovalBadge, ActivityFilterCriteria } from "components";
import { ActivityGroupTotals } from "types/chartData";
import { API_URL } from "App";
import { Control } from "react-hook-form";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { string } from "yargs";
import { HSColumnChart } from "components/charts/HSColumnChart";


type ActivityChartProps = {
  activityGroupTotals?: ActivityGroupTotals[];
  filterForm?: Control;
  isLoading?: boolean;
};







export const ActivityRegionChart: React.FC<ActivityChartProps> = ({ activityGroupTotals, filterForm, isLoading}) => {
  const [chartData, setChartData] = useState<{ name: string; y: number }[]>([]);
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
  const { getLookupDescription } = useContext(LookupsContext);
  //NOTE: For column definitions:
  //      "renderCell" is used to resolve what the grid will use for the actual cell value to display
  //      "valueGetter" is used for sorting and filtering because it is the only way to access the actual data value for the column
  //      "getApplyQuickFilterFn" would be used IF we wanted to use a custom filter function for the column outside of what is displayed
  //      Example:
  //        getApplyQuickFilterFn(value, colDef, apiRef) {
  //          return (params) => {
  //            const cellValue = params.row.fiscalYears.map((fy: any) => (!fy.fiscalYear ? "" : dayjs(fy.fiscalYear).year())).join(" | ");
  //            return cellValue.toString().toLowerCase().includes(value.toLowerCase());
  //          };
  //        },
  //      * When the display is just text from the field itself then "valueGetter" is not needed and "renderCell" can be used for both display and filtering/sorting

  
  
  
  useEffect(() => {
    

    let tmpChartData: { name: string; y: number }[] = [];
    if (activityGroupTotals != null)
    {
      

      for(var i = 0; i < activityGroupTotals.length; i++) {

        if (activityGroupTotals[i].type === "Regions") {

          tmpChartData.push(
            {
              name: activityGroupTotals[i].itemDesc ?? "",
              y: activityGroupTotals[i].value ?? 0
            });
        }
      }
    }
    

setChartData(tmpChartData);


  }, [activityGroupTotals, isLoading]);




  if ((chartData == null || chartData.length <=0) && isLoading === false)
    {
return (<div>No Activities with Attendees matching this filter criteria.</div>);
    }




 
 
  return <HSColumnChart reportCode="ACTIVITYREGIONCODE" chartData={chartData} isLoading={isLoading} />;

};